import PhoneNumberPage from './PhoneNumberPage'

export default PhoneNumberPage